export const isValidColor = (colorHex) => {
    const colorHexRegex = /^[0-9A-F]{6}$/i;

    return colorHexRegex.test(colorHex);
};